import React from 'react';
import { ButtonGroup, Button, useMediaQuery, Tooltip } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { getContrastColor } from '#component/theme';

const StyledButton = styled(Button)(() => ({
  padding: 5
}));

/**
 * Renders Mui ButtonGroup with buttons
 * to change view for location or address
 * @returns {React.Component}
 */

const SwitchView = ({ tab, changeTab, ...props }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const theme = useTheme();

  return (
    <ButtonGroup
      orientation={isMobile ? 'horizontal' : 'vertical'}
      aria-label="address or map"
      {...props}
    >
      <StyledButton onClick={changeTab(0)}>
        <Tooltip title="Show location">
          <LocationOnIcon style={{
            color: tab === 0 ? theme.palette.grey[400] : getContrastColor() }}
          />
        </Tooltip>
      </StyledButton>
      <StyledButton onClick={changeTab(1)}>
        <Tooltip title="Show address">
          <MenuIcon style={{
            color: tab === 1 ? theme.palette.grey[400] : getContrastColor() }}
          />
        </Tooltip>
      </StyledButton>
    </ButtonGroup>
  );
};

export default SwitchView;

SwitchView.propTypes = {
  tab: PropTypes.number.isRequired,
  changeTab: PropTypes.func.isRequired
};
